const animationData: {
  imageSrc: string
  imageSrcSet: string
  text: string
}[] = [
  {
    imageSrc: `/assets/images/mobile-animation/{{language}}/phone1@2x.webp`,
    imageSrcSet: `/assets/images/mobile-animation/{{language}}/phone1.webp 600w, /assets/images/mobile-animation/{{language}}/phone1@2x.webp 2x, /assets/images/mobile-animation/{{language}}/phone1@2x.webp 1200w`,
    text: 'cl_landing_screenshots_block_1_text',
  },
  {
    imageSrc: `/assets/images/mobile-animation/{{language}}/phone2@2x.webp`,
    imageSrcSet: `/assets/images/mobile-animation/{{language}}/phone2.webp 600w, /assets/images/mobile-animation/{{language}}/phone2@2x.webp 2x, /assets/images/mobile-animation/{{language}}/phone2@2x.webp 1200w`,
    text: 'cl_landing_screenshots_block_2_text',
  },
  {
    imageSrc: `/assets/images/mobile-animation/{{language}}/phone3@2x.webp`,
    imageSrcSet: `/assets/images/mobile-animation/{{language}}/phone3.webp 600w, /assets/images/mobile-animation/{{language}}/phone3@2x.webp 2x, /assets/images/mobile-animation/{{language}}/phone3@2x.webp 1200w`,
    text: 'cl_landing_screenshots_block_3_text',
  },
  {
    imageSrc: `/assets/images/mobile-animation/{{language}}/phone4@2x.webp`,
    imageSrcSet: `/assets/images/mobile-animation/{{language}}/phone4.webp 600w, /assets/images/mobile-animation/{{language}}/phone4@2x.webp 2x, /assets/images/mobile-animation/{{language}}/phone4@2x.webp 1200w`,
    text: 'cl_landing_screenshots_block_4_text',
  },
  {
    imageSrc: `/assets/images/mobile-animation/{{language}}/phone5@2x.webp`,
    imageSrcSet: `/assets/images/mobile-animation/{{language}}/phone5.webp 600w, /assets/images/mobile-animation/{{language}}/phone5@2x.webp 2x, /assets/images/mobile-animation/{{language}}/phone5@2x.webp 1200w`,
    text: 'cl_landing_screenshots_block_5_text',
  },
]

export { animationData }
